export default __webpack_public_path__ + "static/media/arrow-dir-3.398a1636.gif";